import { CommonClassNames } from '@dtvgo/classnames';

var SliderClassNames = CommonClassNames.component('slider');
var isLeftButtonMove = function isLeftButtonMove(event) {
  return event.buttons === 1;
};
var isLeftButton = function isLeftButton(event) {
  return isLeftButtonMove(event) || event.button === 0;
};
var stopEventPropagation = function stopEventPropagation(event) {
  return event.stopPropagation();
};

export { SliderClassNames, isLeftButton, isLeftButtonMove, stopEventPropagation };
//# sourceMappingURL=utils.js.map
